<div class="sd-wrapper" tabindex="-1" (focusout)="onFocusOut($event)">
  <div class="sd-input-container">
    <input
      #searchInput
      id="sd-input"
      class="sd-input"
      [class.ng-invalid]="!valid"
      type="text"
      [(ngModel)]="query"
      (input)="onQueryInput()"
      (focus)="open()"
      (click)="open()"
      [placeholder]="getPlaceholder()"
      (keydown.escape)="close(); $event.stopPropagation()"
      autocomplete="off"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
    />
    @if (isLoading) {
      <mat-spinner diameter="20" class="sd-loading-spinner"></mat-spinner>
    }
  </div>

  @if (isOpen && (query?.length || results.length || selected.length)) {
    <div class="sd-panel" aria-label="Search panel">
      <!-- Top section: search results -->
      <div
        #searchResultsContainer
        class="sd-panel-section top"
        tabindex="0"
        (focus)="onSearchResultsFocus()"
        (mousemove)="onMouseMove()"
        (keydown.escape)="close(); $event.stopPropagation()"
        [attr.aria-label]="'Search results, ' + results.length + ' items'"
        role="listbox"
      >
        @if (allowMultiple && results.length) {
          <div class="sd-section-actions">
            <button class="sd-link-btn" (click)="addAll()">Add all</button>
          </div>
        }
        @if (query?.length && !isLoading && !queryQueued && !results.length) {
          <p>No results found</p>
        }
        <mat-list>
          @for (item of results; track item.id; let i = $index) {
            <mat-list-item
              #searchResultItem
              role="option"
              [class.focused]="isItemFocused('search', i)"
              [attr.aria-selected]="isItemFocused('search', i)"
              (click)="selectItem(item.id)"
              (mouseenter)="onMouseEnter()"
              >{{ getItemDisplayLabel(item) }}</mat-list-item
            >
          }
        </mat-list>
      </div>
      <!-- Bottom section: selected items -->
      @if (selected.length) {
        <div
          #selectedItemsContainer
          class="sd-panel-section bottom"
          tabindex="0"
          (focus)="onSelectedItemsFocus()"
          (mousemove)="onMouseMove()"
          (keydown.escape)="close(); $event.stopPropagation()"
          [attr.aria-label]="'Selected items, ' + selected.length + ' items'"
          role="listbox"
        >
          <div class="sd-subtitle-row">
            <div class="sd-subtitle">Selected</div>
            @if (selected.length) {
              <button class="sd-link-btn" (click)="removeAll()">Remove all</button>
            }
          </div>
          <mat-list class="sd-selected-list">
            @for (item of selected; track item.id; let i = $index) {
              <mat-list-item
                #selectedListItem
                role="option"
                [class.focused]="isItemFocused('selected', i)"
                [attr.aria-selected]="isItemFocused('selected', i)"
                (mouseenter)="onMouseEnter()"
              >
                {{ getItemDisplayLabel(item) }}
                <button mat-icon-button class="sd-remove-btn" (click)="removeSelected(item.id)">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
    </div>
  }
</div>
